import { Chip as MaterialChip } from '@material-ui/core';
import styled, { css } from 'styled-components';

import grid from '~/styles/grid';

import alert from '../../../assets/alert.svg';
import colors from '../../../styles/colors';

interface InputProps {
  disabled?: boolean;
}

export const Container = styled.div<InputProps>`
  display: flex;
  flex-direction: column;
  position: relative;
  flex: 1;

  > div:first-child {
    margin: 10px 0 5px 0;
    label {
      font-weight: bold;
    }
    small {
      color: ${colors.gray};
      font-size: 14px;
    }
  }

  input {
    display: none;
    width: 100%;
    border-radius: 5px;
    border: none;
    background-color: ${colors.white} !important;
    height: 50px;
    padding: 0 15px;
    transition: border 0.3s;
    color: transparent;
    font-size: 0;
    &::placeholder {
      display: none;
    }
    &:focus {
      border: solid 1px ${colors.darkgray};
    }

    ${(props) =>
      props.disabled &&
      css`
        background: #f2f2f2;
      `}
  }

  button {
    margin-top: 0 !important;
    margin-right: ${grid.md};
    color: ${colors.darkgray};
    background: none;
    border: none;
  }

  p {
    display: inline-block;
    margin-left: 16px;
    font-size: 20px;
    color: #707070;
  }

  span {
    color: #c11e1e;
    margin: 5px 0;

    &:before {
      content: url(${alert});
      padding: 0 10px 0 0;
      vertical-align: -10%;
    }
  }
`;

export const Content = styled.div<InputProps>`
  display: flex;
  width: 100%;
  height: auto;
  min-height: 50px;
  border-radius: 5px;
  border: 1px solid ${colors.gray};
  background-color: ${colors.white};
  transition: border 0.3s;
  color: transparent;
  font-size: 0;
  cursor: pointer;

  ${(props) =>
    props.disabled &&
    css`
      cursor: block;
      pointer-events: none;
      background-color: #f2f2f2;

      button {
        &:hover {
          color: #4d4d4d;
        }
      }
    `}
`;

export const ChipContainer = styled.div`
  flex: 1;
  align-self: center;
  margin: ${grid.sm};
  display: flex;
  flex-wrap: wrap;
  gap: ${grid.sm};

  span {
    margin: auto 5px auto 0px;
    max-width: 32.143rem;
    font-size: 12px;
    overflow: hidden;
  }
`;

export const Chip = styled(MaterialChip)`
  border-radius: 2px !important;
  background: rgba(255, 153, 184, 0.25) !important;

  svg {
    color: black;
    height: 100%;
    margin-right: 0;
    &:hover {
      color: black;
      background: rgba(255, 153, 184, 0.75) !important;
    }
  }

  span {
    color: black;

    &:before {
      content: none;
    }
  }
`;
